export const LABEL = 'Number';
export const PLACEHOLDER = '1';
export const START_ENHANCER = '#';
